import { AnalyticsProps, SegmentClientOptions } from './analytics.types';

export abstract class AnalyticsClient {
  public abstract reset(): void;
  public abstract track(name: string, props?: AnalyticsProps, options?: SegmentClientOptions): void;
  public abstract alias(id: number, options?: SegmentClientOptions): void;
  public abstract identify(
    userId?: number,
    traits?: Record<string, string | number>,
    options?: SegmentClientOptions,
  ): void;
  public abstract page(
    category: string,
    name: string,
    properties?: any,
    options?: SegmentClientOptions,
  ): void;
}
